<template>
    <div class="rail-wrap fixed bottom-0 top-0 left-0 z-[11] !pl-0">
        <mdui-navigation-rail contained
                              class="nav-rail transition bg-primary-30 p-2 text-white w-[81vw] lg:w-[280px]"
                              :class="{ 'rail-small lg:w-[76px]': !railOpen }">
            <nav class="flex flex-col justify-between w-full" :class="{ 'pt-20 lg:pt-12': props.impersonating }">
                <header class="py-4 px-2">
                    <div class="flex justify-between items-center" :class="{ 'flex-col gap-4 ': !railOpen }">
                        <RouterLink to="/" :title="$t('general.$home')">
                            <img :src="logo" alt="" class="w-[144px]" v-if="railOpen" />
                            <img :src="icon" alt="" class="w-[32px] pt-1" v-else />
                        </RouterLink>
                        <mdui-button-icon :title="$t('general.$close')"
                                          icon="close--outlined"
                                          @click="hidemenu"
                                          variant="standard"
                                          class="text-tertiary-fixed cursor-pointer lg:hidden text-28"></mdui-button-icon>
                        <mdui-button-icon class="open-button text-tertiary-fixed text-28 hidden lg:block mdui-theme-dark rotate-180"
                                          icon="menu_open"
                                          :title="$t('general.$expand')"
                                          slot="top"
                                          variant="standard"
                                          v-if="!railOpen"
                                          @click="showrail"></mdui-button-icon>
                        <mdui-button-icon class="close-button text-tertiary-fixed text-28 hidden lg:block mdui-theme-dark"
                                          icon="menu_open"
                                          :title="$t('general.$minimize')"
                                          slot="top"
                                          variant="standard"
                                          v-else
                                          @click="hiderail"></mdui-button-icon>
                    </div>

                    <ul class="py-8 pb-3 flex flex-col" :class="{ 'items-center': !railOpen }" v-if="store.currentUser && store.currentUser.isAdmin">
                        <li>
                            <RouterLink to="/admin/impersonate-customer" class="btn-nav" @click="hidemenu">
                                <mdui-icon name="supervisor_account--outlined" v-if="railOpen"></mdui-icon>
                                <mdui-button-icon icon="supervisor_account--outlined" :title="$t('nav.$impersonateCustomer')" v-else></mdui-button-icon>
                                <span v-if="railOpen">{{ $t('nav.$impersonateCustomer') }}</span>
                            </RouterLink>
                        </li>
                        <li>
                            <RouterLink to="/admin/invite-users" class="btn-nav" @click="hidemenu">
                                <mdui-icon name="list_alt--outlined" v-if="railOpen"></mdui-icon>
                                <mdui-button-icon icon="list_alt--outlined" :title="$t('nav.$inviteUsers')" v-else></mdui-button-icon>
                                <span v-if="railOpen">{{ $t('nav.$inviteUsers') }}</span>
                            </RouterLink>
                        </li>
                    </ul>
                    <ul class="py-8 pb-3 flex flex-col gap-2" :class="{ 'items-center': !railOpen }" v-else>
                        <li v-if="perms?.hasAccessToDashboard">
                            <RouterLink to="/dashboard" class="btn-nav" @click="hidemenu">
                                <mdui-icon name="view_comfy--outlined" v-if="railOpen"></mdui-icon>
                                <mdui-button-icon icon="view_comfy--outlined" :title="$t('nav.$dashboard')" v-else></mdui-button-icon>
                                <span v-if="railOpen">{{ $t('nav.$dashboard') }}</span>
                            </RouterLink>
                        </li>
                        <li v-if="perms?.hasAccessToOrderItemsTab">
                            <RouterLink to="/order" class="btn-nav" @click="hidemenu">
                                <mdui-icon name="list_alt--outlined" v-if="railOpen"></mdui-icon>
                                <mdui-button-icon icon="list_alt--outlined" :title="$t('nav.$order')" v-else></mdui-button-icon>
                                <span v-if="railOpen">{{ $t('nav.$order') }}</span>
                            </RouterLink>
                        </li>
                        <li v-if="perms?.hasAccessToCartTab">
                            <RouterLink to="/cart" class="btn-nav" @click="hidemenu">
                                <mdui-icon name="shopping_cart--outlined" v-if="railOpen"></mdui-icon>
                                <mdui-button-icon icon="shopping_cart--outlined" :title="$t('nav.$cart')" class="text-white" v-else></mdui-button-icon>
                                <span v-if="railOpen">{{ basketCount ? $t('nav.$cart') + ' (' + basketCount + ')' : $t('nav.$cart') }}</span>
                            </RouterLink>
                        </li>
                        <li v-if="perms?.hasAccessToDocumentsTab">
                            <RouterLink to="/documents" class="btn-nav" @click="hidemenu">
                                <mdui-icon name="folder_open--outlined" v-if="railOpen"></mdui-icon>
                                <mdui-button-icon icon="folder_open--outlined" :title="$t('nav.$documents')" v-else></mdui-button-icon>
                                <span v-if="railOpen">{{ $t('nav.$documents') }}</span>
                            </RouterLink>
                        </li>
                        <li v-if="perms?.hasAccessToPreviousOrdersTab">
                            <RouterLink to="/orders" class="btn-nav" @click="hidemenu">
                                <mdui-icon name="inventory_2--outlined" v-if="railOpen"></mdui-icon>
                                <mdui-button-icon icon="inventory_2--outlined" :title="$t('nav.$orders')" class="text-white" v-else></mdui-button-icon>
                                <span v-if="railOpen">{{ $t('nav.$orders') }}</span>
                            </RouterLink>
                        </li>
                    </ul>
                </header>
            </nav>
            <div class="w-full px-2 pb-3 flex flex-col gap-2.5 items-start" slot="bottom">
                <template v-if="docpageLink && isDanish">
                    <mdui-button v-if="railOpen"
                                 icon="info--outlined" variant="filled"
                                 :href="docpageLink"
                                 class="w-full"
                                 :class="{ 'bg-primary-container text-on-primary-container hover:brightness-110 transition-all': isRecentlyUpdated }"
                                 size="large">
                        {{ docpageButton }}
                        <span class="block body-xsmall" v-if="showUpdateDate">{{ $t('content.$latestUpdate') }} {{ formatDate(lastUpdated ?? undefined, store.lang) }}</span>
                    </mdui-button>
                    <mdui-button-icon v-else
                                      :title="docpageButton"
                                      icon="info--outlined"
                                      :href="docpageLink"
                                      class="text-28"
                                      :class="isRecentlyUpdated ? 'bg-primary-container text-on-primary-container hover:brightness-110 transition-all' : 'mdui-theme-dark text-primary'">
                    </mdui-button-icon>
                </template>
                <mdui-dropdown v-if="railOpen">
                    <mdui-button slot="trigger" icon="language" variant="text" class="mdui-theme-dark text-primary">
                        {{ formatLanguage(store.lang) }}
                    </mdui-button>
                    <mdui-menu selects="single" :value="store.lang" @change="changeLanguage($event.target.value)">
                        <mdui-menu-item v-for="language in store.languages" :key="language" :value="language">
                            {{ formatLanguage(language) }}
                        </mdui-menu-item>
                    </mdui-menu>
                </mdui-dropdown>
                <mdui-dropdown v-else>
                    <mdui-button-icon slot="trigger" :title="$t('general.$language')" icon="language" class="mdui-theme-dark text-primary text-28"></mdui-button-icon>
                    <mdui-menu selects="single" :value="store.lang" @change="changeLanguage($event.target.value)">
                        <mdui-menu-item v-for="language in store.languages" :key="language" :value="language">
                            {{ formatLanguage(language) }}
                        </mdui-menu-item>
                    </mdui-menu>
                </mdui-dropdown>
            </div>
        </mdui-navigation-rail>
    </div>
</template>

<script setup lang="ts">
    import { computed, ref, defineProps } from 'vue';
    import { useStore } from '@/store';
    import { useI18n } from 'vue-i18n';
    import emitter, { Events } from '@/event';
    import { formatDate } from '@/helpers/datehelpers';
    import 'mdui/components/icon.js';
    import 'mdui/components/button.js';
    import 'mdui/components/dropdown.js';
    import 'mdui/components/menu.js';
    import 'mdui/components/menu-item.js';
    import AxiosFactory from '@/services/axiosFactory';
    import 'mdui/components/navigation-rail.js';
    import 'mdui/components/navigation-rail-item.js';
    import type { NavigationRail } from 'mdui/components/navigation-rail.js';
    import type { NavigationRailItem } from 'mdui/components/navigation-rail-item.js';

    // Props
    const props = defineProps<{
        impersonating?: boolean
        railOpen?: boolean
    }>();

    // Usings
    const store = useStore();
    const { t } = useI18n();

    // Data
    const logo = ref('');
    const icon = ref('');
    const docpageLink = ref<string>('');
    const docpageButton = ref<string>('');
    const lastUpdated = ref<Date | null>(null);
    const docpageDays = ref<number>(5);
    const docpageMonths = ref<number>(4);

    // We hardcode docpages to Danish only, for now.
    const isDanish = computed(() => {
        const lang = store.lang?.toLowerCase();
        return lang === 'da' || lang === 'da-dk';
    });

    const showUpdateDate = computed(() => {
        if (!lastUpdated.value) return false;

        const monthsAgo = new Date();
        monthsAgo.setMonth(monthsAgo.getMonth() - docpageMonths.value);

        return lastUpdated.value > monthsAgo;
    });

    const isRecentlyUpdated = computed(() => {
        if (!lastUpdated.value) return false;
        const daysAgo = new Date();
        daysAgo.setDate(daysAgo.getDate() - docpageDays.value);
        return lastUpdated.value > daysAgo;
    });

    const basketCount = computed(() => {
        return store.basket ? store.basket.lineItems.length : 0;
    });

    // Extract permissions once, reactive with currentDebitor changes
    const perms = computed(() => store.currentDebitor?.debitorPermissions);

    // Lifecycle
    const bodyAttributes = document.querySelector('body');
    logo.value = bodyAttributes?.getAttribute('data-tertiary-logo') ?? '';
    icon.value = bodyAttributes?.getAttribute('data-tertiary-icon') ?? '';
    docpageLink.value = bodyAttributes?.getAttribute('data-docpage-link') ?? '';
    docpageButton.value = bodyAttributes?.getAttribute('data-docpage-button') ?? '';

    const rawUpdatedDate = bodyAttributes?.getAttribute('data-docpage-updated');
    if (rawUpdatedDate) {
        lastUpdated.value = new Date(rawUpdatedDate);
    }

    const rawDays = bodyAttributes?.getAttribute('data-docpage-days');
    if (rawDays) docpageDays.value = parseInt(rawDays);

    const rawMonths = bodyAttributes?.getAttribute('data-docpage-months');
    if (rawMonths) docpageMonths.value = parseInt(rawMonths);

    // Methods
    function changeLanguage(language: string) {
        store.lang = language;
        AxiosFactory.setLanguage(language);
        location.reload();
    }

    function hidemenu() {
        emitter.emit(Events.HideMenu);
    }

    function showrail() {
        emitter.emit(Events.ShowRail);
    }
    function hiderail() {
        emitter.emit(Events.HideRail);
    }

    function formatLanguage(language: string) {
        // Normalize the code to lowercase for robust matching
        const code = language.toLowerCase();

        switch (code) {
            case 'da-dk':
            case 'da':
                return t('nav.$danish');
            case 'en-us':
            case 'en':
                return t('nav.$english');
            case 'pl':
            case 'pl-pl':
                return t('nav.$polish');
            case 'uk':
            case 'uk-ua':
                return t('nav.$ukrainian');
            default:
                // If it's something else, return the raw code or attempt browser lookup
                return language;
        }
    }
</script>
